// 语言元数据：码 / 原生名 / 对应 Vant 内置语言包。
//
// 码与 Android `ComAppLanguageType` 完全对齐——后端没有专门「设置语言」接口，
// 靠每次请求的 `Language` 头同步内容，认这些码（zh-TW 保留大小写，其余小写）。
// label 一律用该语言的本族文字（下拉里各语言显示自己）。
// vant 字段是该语言对应的 Vant 内置语言包名；没有对应包的回退 en-US。

export type AppLocale =
  | "zh"
  | "en"
  | "th"
  | "ms"
  | "vi"
  | "id"
  | "hi"
  | "zh-TW"
  | "tl"
  | "bn";

export interface LocaleMeta {
  code: AppLocale;
  /** 下拉里展示的名字（用该语言本族文字） */
  label: string;
  /** 对应的 Vant 内置语言包名；无对应包的填 en-US */
  vant: string;
}

export const LOCALES: Record<AppLocale, LocaleMeta> = {
  zh: { code: "zh", label: "简体中文", vant: "zh-CN" },
  en: { code: "en", label: "English", vant: "en-US" },
  th: { code: "th", label: "ไทย", vant: "th-TH" },
  ms: { code: "ms", label: "Bahasa Melayu", vant: "en-US" }, // Vant 无 ms 包
  vi: { code: "vi", label: "Tiếng Việt", vant: "vi-VN" },
  id: { code: "id", label: "Bahasa Indonesia", vant: "id-ID" },
  hi: { code: "hi", label: "हिन्दी", vant: "hi-IN" },
  "zh-TW": { code: "zh-TW", label: "繁體中文", vant: "zh-TW" },
  tl: { code: "tl", label: "Filipino", vant: "en-US" }, // Vant 无 tl 包
  bn: { code: "bn", label: "বাংলা", vant: "bn-BD" },
};
